import { render, staticRenderFns } from "./ReturnConfirmation.vue?vue&type=template&id=27037102"
import script from "./ReturnConfirmation.vue?vue&type=script&lang=js"
export * from "./ReturnConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports